import { ReactComponent as EditIcon } from '@Icons/additional/edit.svg';

import styles from './edit-action.module.css';

interface EditActionProps {
  status: string;
  handleEdit: () => void;
}

const EditAction: React.FC<EditActionProps> = ({ status, handleEdit }) => {
  if (status !== 'Open') return null;

  return (
    <div className={styles.editAction} onClick={handleEdit}>
      <EditIcon />
    </div>
  );
};

export default EditAction;
